import { z } from 'zod';

import { parseConfig } from './parse-config';

export const hostnameSchema = z.string().default('localhost');

export const hostname = parseConfig('hostname configuration', hostnameSchema, process.env.HOSTNAME);
